import React from 'react'
import FileUploaderWithActions from 'src/components/common/form-elements/FileUploaderWithActions'
import { ErrorType } from 'src/lib/hooks/useCSVValidator'
import { CustomerEligibilityOptions, CustomerEligibilityStateType } from 'src/lib/types/common/customerConditions'
import { FileTypeOptions } from 'src/lib/types/common/files'
import FormErrorText from 'src/components/common/FormErrorText'

import { FlowErrorType } from 'src/lib/types/common/error'

interface SpecificPincodesProps {
  state: Extract<CustomerEligibilityStateType, { type: CustomerEligibilityOptions.SPECIFIC_PINCODES }>
  onChange: (value: CustomerEligibilityStateType) => void
  error?: FlowErrorType
}

const SpecificPincodes: React.FC<SpecificPincodesProps> = ({ state, onChange, error }) => {
  const { uploadedFile } = state
  return (
    <div className='pb-2'>
      <div className='flex flex-col gap-2 pt-1 pb-5 border-b border-dotted border-zinc-200'>
        <FileUploaderWithActions
          buttonText='Upload CSV'
          type='.csv'
          uploadLink='/attributes/v1/files/upload'
          size='medium'
          variant='dashed'
          color='primary'
          acceptedSize={104857600}
          prevUploadedFileURL={uploadedFile?.url}
          prevUploadedFileName={uploadedFile?.name}
          prevUploadedFileSize={uploadedFile?.size}
          setUploadedFileData={(fileData: any) => {
            onChange({
              ...state,
              uploadedFile: {
                url: fileData.url,
                name: fileData.name,
                size: fileData.size || 0,
                type: FileTypeOptions.CSV,
                count: 0
              }
            })
          }}
          setSelectedCSVFormData={(data: any) => {
            if (data === 'DELETED') {
              onChange({
                ...state,
                uploadedFile: {
                  url: '',
                  name: '',
                  size: 0,
                  type: FileTypeOptions.CSV,
                  count: 0
                }
              })
            }
          }}
          errorsToCheck={[ErrorType.FILE_SIZE_EXCEEDED, ErrorType.CUSTOMER_PHONE_NUMBERS]}
        />
        <p className='text-text-xs-regular text-zinc-500'>
          Need a sample .csv file?{' '}
          <a
            id='sample-csv-download'
            href='https://documents.shopflo.com/sample_pincodes.csv'
            className='text-text-xs-medium underline underline-offset-2 cursor-pointer'
          >
            Download
          </a>
        </p>
      </div>
      {error?.status && <FormErrorText message={error.message} />}
    </div>
  )
}

export default SpecificPincodes
